const ValidateLicenceModel = (licenceInfo) => {
  const newErrors = {};

  // Validate IssueBy
  if (!licenceInfo.IssueBy.trim()) {
    newErrors.IssueBy = "This field is required.";
  }else if( !/^[a-zA-Z0-9\\\/_#;,@'\- ]*$/.test(licenceInfo.IssueBy)){
     newErrors.IssueBy = `Characters allowed: a-z A-Z 0-9 \\ / _ # ; , @ ' -`;
  }

  // Validate License Number
  if (!licenceInfo.LicenseNumber.trim()) {
    newErrors.LicenseNumber = "This field is required.";
  } else if (!/^[a-zA-Z0-9\-#,.()&'"` ]*$/i.test(licenceInfo.LicenseNumber)) {
    newErrors.LicenseNumber = `Characters allowed a-z A-Z 0-9 and - # , . () & ' " ${"`"}`;
  }

  // Validate Expiry Date
  if (!licenceInfo.ExpiryDate) {
    newErrors.ExpiryDate = "This field is required.";
  } else {
     const currentDate = new Date();
            const expiryDate = new Date(licenceInfo.ExpiryDate);

            if (isNaN(expiryDate.getTime())) {
              newErrors.ExpiryDate = "Please Enter a Valid Date format MM/DD/YYYY";
            } else if (expiryDate < currentDate) {
              newErrors.ExpiryDate =
              "Please Enter a Valid Date format MM/DD/YYYY";
                // "License has expired. Please enter a future date";
            }
  }

  if(licenceInfo.zipcode && !/^[0-9]{5}$/i.test(licenceInfo.zipcode)){
 newErrors.zipcode = "Please enter a valid zipcode";
  }
  if(!/^[a-zA-Z0-9#(),'\s]*$/.test(licenceInfo.AddressLine2)){
 newErrors.AddressLine2 = "Please enter a valid street address";
  }
  if(!/^[a-zA-Z0-9#(),'\s]*$/.test(licenceInfo.AddressLine1)){
     newErrors.AddressLine1 = "Please enter a valid address";
  }
  if(!licenceInfo?.state){
    newErrors.state = "This field is required.";
  }

  // Validate Address
  // if (!licenceInfo.AddressLine1.trim()) {
  //   newErrors.AddressLine1 = "Address is required";
  // }

  // Validate City
  // if (!licenceInfo.city.trim()) {
  //   newErrors.city = "City is required";
  // }

  // Validate Zipcode
  // if (!licenceInfo.zipcode.trim()) {
  //   newErrors.zipcode = "Zipcode is required";
  // } else if (!/^\d{5}(-\d{4})?$/.test(licenceInfo.zipcode)) {
  //   newErrors.zipcode = "Invalid zipcode format";
  // }

  // Validate Status
  // if (!licenceInfo.Status) {
  //   newErrors.Status = "Status is required";
  // }

  return {
    isValid: Object.keys(newErrors).length === 0,
    newErrors,
  };
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0; // Returns true if no errors
};

export default ValidateLicenceModel;
